export default "__VITE_PUBLIC_ASSET__5f453681__"